// Declare our own LINE_CAP enum that's 1:1 with Pixi.
//
// This is because pixi/graphics library has some code which auto-executes parts of pixi/core.
// That code references `document` object within it, therefore importing these styles in workers causes a runtime error.
export var LINE_CAP;
(function (LINE_CAP) {
    LINE_CAP["BUTT"] = "butt";
    LINE_CAP["ROUND"] = "round";
    LINE_CAP["SQUARE"] = "square";
})(LINE_CAP || (LINE_CAP = {}));
